<template>
  <div class="animated fadeIn fontfamaliy">
    <b-row class="bulkshipment_tracking">
      <b-col sm="12">
        <b-card>
          <template #header>
            <div class="d-flex justify-content-between align-items-center w-100">
              <span class="font-weight-bold">Bulk Shipment Tracking</span>
              <div class="d-flex align-items-center">
                <router-link :to="{
                            path: '/consignmenttracking_mr/normal'
                        }">
                  <b-button variant="outline-dark" size="sm">Shipment Tracking</b-button>
                </router-link>
              </div>
            </div>
          </template>
          <!-- Header -->
          <!-- Search Area -->
          <form @submit.prevent="searchData" data-vv-scope="bulktracking">
            <b-row>
              <b-col md="12">
                <b-form-group label="AWB / Load ID" :label-cols="2">
                  <b-form-textarea v-model.trim="searching" rows="6" max-rows="10" placeholder="Enter AWB / Load IDs"></b-form-textarea>
                </b-form-group>
                <div class="text-danger mb-3">
                  <b>
                    Note : Comma Separated,Space Separated and Tabular forms are allowed.
                  </b>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-button variant="primary" class="mr-2" type="submit" :disabled="isBusy">Search</b-button>
                <b-button variant="danger" class="mr-2" @click="clear" :disabled="isBusy">Clear</b-button>
                <b-button variant="success" @click="download" v-if="totalcount" :disabled="isBusy">Download</b-button>
              </b-col>
            </b-row>
          </form>
          <hr>
          <!-- Total Records -->
          <div class="text-right mb-2" v-if="totalcount">
            <b>
              Total Records : {{ totalcount }}
            </b>
          </div>
          <!-- Table -->
          <b-table
                show-empty
                hover
                responsive
                outlined
                bordered
                :busy="isBusy"
                :items="items"
                :fields="fields"
                class="bulk-table"
                :per-page="0"
                :current-page="1">
            <template #table-busy>
              <div class="text-center my-3">
                <b-spinner></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
            <template #empty>
              <div class="text-center">No Records Found</div>
            </template>
          </b-table>
          <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                @change="pageChanged"></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import axios from "axios";
  import Swal from "sweetalert2";
  export default {
    name: "BulkShipmentTracking",
    data() {
      return {
        //---------------------------------
        // Search
        //---------------------------------
        searching: "",
        searchvaluesarr: [],
        //---------------------------------
        // Table
        //---------------------------------
        items: [],
        totalcount: 0,
        isBusy: false,
        outlined: true,
        bordered: true,
        //---------------------------------
        // Download
        //---------------------------------
        loadurl: "",
        //---------------------------------
        // User
        //---------------------------------
        customer: {},
        status: "",
        currentPage: 1,
        perPage: 100,
        totalRows: 0,
        //---------------------------------
        // Table Columns
        //---------------------------------
        fields: [ {
          key: "userid",
          label: "User ID"
        }, {
          key: "parentawb",
          label: "Parent AWB"
        }, {
          key: "loadid",
          label: "Load ID"
        }, {
          key: "accounttype",
          label: "Account Type"
        }, {
          key: "assigneddate",
          label: "Assigned Date"
        }, {
          key: "invoicevalue",
          label: "Invoice Value"
        }, {
          key: "mpscount",
          label: "MPS Count"
        }, {
          key: "actualweight",
          label: "Actual Weight"
        }, {
          key: "volumetricweight",
          label: "Volumetric Weight"
        }, {
          key: "deliverystatus",
          label: "Delivery Status"
        }, {
          key: "shipmentstatus",
          label: "Shipment Status"
        }, {
          key: "hubname",
          label: "Hub Name"
        }, {
          key: "zonename",
          label: "Zone Name"
        }, {
          key: "vehicleno",
          label: "Vehicle No."
        }, {
          key: "transportername",
          label: "Transporter Name"
        }, {
          key: "vehiclename",
          label: "Vehicle Name"
        }, {
          key: "origincity",
          label: "Origin City"
        }, {
          key: "originstate",
          label: "Origin State"
        }, {
          key: "destinationcity",
          label: "Destination City"
        }, {
          key: "destinationstate",
          label: "Destination State"
        }, {
          key: "companyname",
          label: "Company Name"
        }, {
          key: "manualdelivery",
          label: "Manual Delivery"
        }, {
          key: "ofddate",
          label: "OFD Date"
        }, {
          key: "deliverydate",
          label: "Delivery Date"
        }, {
          key: "ebnno",
          label: "EBN No."
        }, {
          key: "expirydate",
          label: "Expiry Date"
        }, {
          key: "lastmodifiedat",
          label: "Last Modified At"
        }, {
          key: "lastmodifieddate",
          label: "Last Modified Date"
        }, {
          key: "lastmodifiedby",
          label: "Last Modified By"
        }, {
          key: "edd",
          label: "EDD"
        } ]
      };
    },
    created() {
      const userdata = sessionStorage.getItem("b2cuserData");
      if (userdata) {
        this.customer = JSON.parse(userdata);
      }
    },
    methods: {
      pageChanged(page) {
        this.currentPage = page;
        this.shipmentListing();
      },
      //------------------------------------
      // Search
      //------------------------------------
      searchData() {
        this.currentPage = 1;
        this.searchvaluesarr = [];
        if (!this.searching || !this.searching.trim()) {
          this.$fire({
            type: "error",
            text: "Please enter AWB / Load ID."
          });
          return;
        }
        const ids = this.searching.trim().split(/[\s,\t\r\n,]+/).map(item => item.trim()).filter(item => item);
        this.searchvaluesarr = [ ...new Set(ids) ];
        if (this.searchvaluesarr.length === 0) {
          this.$fire({
            type: "error",
            text: "No valid AWB / Load ID found."
          });
          return;
        }
        if (this.searchvaluesarr.length > 15e3) {
          this.$fire({
            type: "error",
            text: "Maximum 15000 AWB / Load IDs allowed."
          });
          return;
        }
        this.shipmentListing();
      },
      //------------------------------------
      // Search API
      //------------------------------------
      shipmentListing() {
        this.items = [];
        this.totalcount = 0;
        this.isBusy = true;
        const payload = {
          searchValues: this.searchvaluesarr,
          page: this.currentPage,
          limit: this.perPage
        };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/bulkShipmentTracking`, payload).then(result => {
          this.isBusy = false;
          if (result.body && result.body.returnmsg === "Successful") {
            this.items = result.body.returnvalue || [];
            this.totalRows = result.body.totalcount || 0;
            this.totalcount = result.body.totalcount || 0;
          } else {
            this.items = [];
            this.totalcount = 0;
            this.$fire({
              type: "error",
              text: result.body.returnvalue || "No records found."
            });
          }
        }).catch(error => {
          this.isBusy = false;
          console.error(error);
          this.$fire({
            type: "error",
            text: "Unable to fetch shipment details."
          });
        });
      },
      //------------------------------------
      // Download CSV
      //------------------------------------
      download() {
        if (!this.searchvaluesarr.length) {
          return;
        }
        const payload = {
          searchValues: this.searchvaluesarr
        };
        this.isBusy = true;
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/bulkShipmentTrackingCSV`, payload, {
          responseType: "blob"
        }).then(response => {
          this.isBusy = false;
          const blob = new Blob([ response.body ], {
            type: "text/csv;charset=utf-8;"
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "BulkShipmentTracking.csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(error => {
          this.isBusy = false;
          console.error(error);
          this.$fire({
            type: "error",
            text: "Download failed."
          });
        });
      },
      //------------------------------------
      // Clear
      //------------------------------------
      clear() {
        this.searching = "";
        this.searchvaluesarr = [];
        this.items = [];
        this.totalcount = 0;
        this.totalRows = 0;
        this.currentPage = 1;
        this.loadurl = "";
        this.errors.clear();
      }
    }
  };
</script>
<style scoped>
  .bulkshipment_tracking .card {
    overflow: hidden;
  }
  /* Search Textarea */
  textarea {
    font-family: Consolas, Monaco, monospace;
    font-size: 14px;
    resize: vertical;
  }
  /* Red Note */
  .text-danger b {
    font-size: 13px;
  }
  /* Table */
  .bulk-table {
    white-space: nowrap;
    font-size: 13px;
  }
  .bulk-table table {
    min-width: 4500px;
  }
  /* Responsive Table */
  .table-responsive {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 70vh;
  }
  /* Table Header */
  .bulk-table thead th {
    background: #f8f9fa;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }
  /* Table Body */
  .bulk-table tbody td {
    vertical-align: middle;
    white-space: nowrap;
  }
  /* Loading */
  .table td, .table th {
    padding: .45rem;
  }
  /* Buttons */
  .btn {
    min-width: 100px;
  }
  /* Total Record */
  .text-right b {
    font-size: 15px;
  }
  /* Sticky Header (Optional) */
  .bulk-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
  }
  /* Card */
  .card-header {
    font-weight: bold;
  }
  /* Scrollbar */
  .table-responsive::-webkit-scrollbar {
    height: 10px;
    width: 10px;
  }
  .table-responsive::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .table-responsive::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
  }
  .table-responsive::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  /* Mobile */
  @media (max-width:768px) {
    .btn {
      width: 100%;
      margin-bottom: 10px;
    }
    .card-header {
      display: block !important;
    }
    .card-header-actions {
      margin-top: 10px;
      text-align: right;
    }
  }
</style>
